<template>
  <div v-if="showSuccess" class="flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-buy">
    <div class="vx-col w-full sm:w-2/3 md:w-2/3 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg">
              <div class="p-6">

                <div class="vx-card__title mb-4 text-center">
                  <span>
                    <vs-icon icon="check" size="large" color="rgb(40, 199, 111)"></vs-icon>
                  </span>
                  <h3 class="mb-4"> Thank you for purchase with us, wish you a good day</h3>
                </div>

                <div>
                  <div class="vx-col w-full">
                    <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
                  </div>
                </div>

                <div class="vx-card__title mb-4 text-center">
                  <vs-button  class="mt-6" ref="loadingbutton" @click="redirect()" >Back</vs-button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
  <div v-else-if="!showSuccess" class="flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-buy">
    <div class="vx-col w-full sm:w-2/3 md:w-2/3 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg">
              <div class="p-6">

                <div class="vx-card__title mb-4 text-center">
                  <span>
                    <vs-icon icon="close" size="large" color="rgb(255,0,0)"></vs-icon>
                  </span>
                  <h3 class="mb-4"> Payment not complete, kindly contact our support.</h3>
                </div>

                <div>
                  <div class="vx-col w-full">
                    <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
                  </div>
                </div>

                <div class="vx-card__title mb-4 text-center">
                  <vs-button  class="mt-6" ref="loadingbutton" @click="redirect()" >Back</vs-button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import axios from '@/axios';
import router from '@/router';

export default {
  components: {
  },
  data(){
    return {
      showSuccess : false,
      order_id : this.$route.params.orderid,
      payment_intent : '',
      payment_intent_client_secret : ''
    }
  },
  mounted() {
  },
  created() {
    this.validate();
  },
  methods : {
    async validate(){
      let uri = window.location.href.split('?');
      if (uri.length == 2)
      {
        let vars = uri[1].split('&');
        let getVars = {};
        let tmp = '';
        for(let v of vars){
          tmp = v.split('=');
          if(tmp.length == 2)
          getVars[tmp[0]] = tmp[1];
        }
        // do 
        this.order_id = this.$route.params.orderid;
        this.payment_intent = getVars.payment_intent;
        this.payment_intent_client_secret = getVars.payment_intent_client_secret;
      }
      
      try {
        this.$vs.loading();
        // 
        let order_id = this.$route.params.orderid;
        let callback_payload = {
          order_id : this.order_id,
          payment_intent : this.payment_intent,
          payment_intent_client_secret : this.payment_intent_client_secret,
          payment_gateway_id : 5
        }
      
        let order = await this.$store.dispatch('buyer/validateFPXOrder',callback_payload)
        if(order == order_id){
          this.showSuccess = true;
        }
        this.$vs.loading.close();
      }catch (e) {
        throw e;
      }
    },
    redirect(){
      window.location.href = window.location.origin
    }
  }
}
</script>